(ns rothko.component.core
  (:require [clojure.spec.alpha :as s]
            [clojure.core.specs.alpha :as specs]
            [clojure.spec.test.alpha :as st]
            #?(:cljs [reagent.core :as r])
            [medley.core :refer [remove-keys]]
            [rothko.common :refer [merge-into]]
            [rothko.component.spec :as component-spec]
            #?@(:cljs [[rothko.component.error-boundary :as error-boundary]
                       [rothko.theme.core :as theme]])
            [taoensso.timbre :as log])
  #?(:cljs (:require-macros [rothko.component.core :refer [defcomp]])))

#?(:cljs
   (defn ensure-props-and-children
     [component]
     (fn []
       (let [this (r/current-component)
             props (r/props this)
             children (r/children this)]
         (into [component props] children)))))

#?(:cljs
   (defn ensure-props-attrs-and-children
     [component {:keys [attrs]}]
     (fn []
       (let [this (r/current-component)
             props (r/props this)
             props' (apply dissoc props attrs)
             attrs (select-keys props attrs)
             children (r/children this)]
         (into [component props' attrs] children)))))

#?(:cljs
   (defn with-props
     [component extra-props]
     (ensure-props-and-children
      (fn props-inner [props & children]
        (into [component (merge-into extra-props props)] children)))))

#?(:cljs
   (defn with-classes
     [component classes]
     (let [classes (if (vector? classes) classes [classes])]
       (with-props component {:class classes}))))

#?(:cljs
   (defn with-theme
     [component component-type]
     (fn theme-wrapper [props & children]
       [theme/consumer {:component-type component-type}
        (into [component props] children)])))

#?(:cljs (goog-define ^boolean DEBUG false))

;; TODO: `appearance` and `theme` props are not checked against what's available
;; TODO: `attrs` should be verified
;; TODO: use spec alpha2 select for attr extraction
#?(:clj
   (defmacro defcomp [& args]
     (let [{fn-name :fn-name
            {:keys [attrs component-type form-component? spec theme?]} :meta
            [_ {[_ body] :body params :params}] :fn-tail}
           (s/conform ::specs/defn-args args)
           fn-name* (symbol (str fn-name "*"))
           inner-args (flatten (s/unform ::specs/param-list params))]
       `(do

          ~(when (not= {:ampersand '& :var-form [:local-symbol 'children]}
                       (:var-params params))
             (let [message# (str fn-name ": `defcomp` without children doesn't currently instrument correctly")]
               (log/info message#)
               `(log/info ~message#)))

          (defn ~fn-name*
            [~@inner-args]
            ~@body)

          (when goog.DEBUG
            (cljs.spec.alpha/fdef ~fn-name* :args ~(or spec `::component-spec/defcomp-args))
            (cljs.spec.test.alpha/instrument (resolve '~fn-name*)))

          (def ~fn-name
            (cond-> ~fn-name*
              ~theme? (with-theme ~component-type)
              true ~(if attrs
                      `(ensure-props-attrs-and-children {:attrs ~attrs})
                      `ensure-props-and-children)
              goog.DEBUG rothko.component.error-boundary/with-error-boundary
              ;; TODO: form components should implement a protocol in form system re-write
              ~form-component? (with-meta {:form-component? true})))))))
